export default __webpack_public_path__ + "static/media/Clock-grad.f7cf1157.png";